module.exports = __webpack_public_path__ + "img/veritas_logo.24540831.png";